import {
  Component, ChangeDetectionStrategy, inject, NgZone,
  OnInit, OnDestroy, signal, input,
} from '@angular/core';

@Component({
  selector: 'widget-dijital-saat',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dijital-saat">
      <div class="saat-satiri">
        <span class="rakamlar">{{ saat() }}</span>
        <span class="ayirici" [class.blink]="true">:</span>
        <span class="rakamlar">{{ dakika() }}</span>
        @if (saniyeGoster()) {
          <span class="ayirici" [class.blink]="true">:</span>
          <span class="rakamlar saniye">{{ saniye() }}</span>
        }
      </div>
      @if (tarihGoster()) {
        <div class="tarih-satiri">{{ tarih() }}</div>
      }
    </div>
  `,
  styles: [`
    :host { display: block; }
    .dijital-saat { text-align: center; font-family: 'SF Mono', Consolas, 'Courier New', monospace; }
    .saat-satiri { display: flex; align-items: baseline; justify-content: center; gap: 2px; }
    .rakamlar { font-size: 2.2em; font-weight: 700; color: var(--py-metin, #e0e0e0); letter-spacing: 2px; }
    .rakamlar.saniye { font-size: 1.6em; opacity: 0.7; }
    .ayirici {
      font-size: 2.2em; font-weight: 700; color: var(--py-metin, #e0e0e0);
      &.blink { animation: saat-blink 1s step-end infinite; }
    }
    .tarih-satiri {
      margin-top: 4px; font-size: 0.85em; opacity: 0.6;
      color: var(--py-metin-ikincil, #aaa);
    }
    @keyframes saat-blink { 50% { opacity: 0; } }
  `],
})
export class DijitalSaatComponent implements OnInit, OnDestroy {
  private zone = inject(NgZone);

  tarihGoster = input(true);
  saniyeGoster = input(true);

  saat = signal('00');
  dakika = signal('00');
  saniye = signal('00');
  tarih = signal('');

  private interval: any;

  ngOnInit() {
    this.guncelle();
    this.zone.runOutsideAngular(() => {
      this.interval = setInterval(() => this.guncelle(), 1000);
    });
  }

  private guncelle() {
    const now = new Date();
    this.saat.set(String(now.getHours()).padStart(2, '0'));
    this.dakika.set(String(now.getMinutes()).padStart(2, '0'));
    this.saniye.set(String(now.getSeconds()).padStart(2, '0'));
    if (this.tarihGoster()) {
      this.tarih.set(now.toLocaleDateString('tr-TR', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
      }));
    }
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
